/**
 * Category Header Component - Vanilla JavaScript with BEM
 * Handles interactive functionality for the category header section
 */

class CategoryHeader {
  constructor(element) {
    this.element = element;
    this.button = element.querySelector('.c-category-header__button');
    this.init();
  }

  init() {
    if (this.button) {
      this.addButtonInteractions();
      this.addAccessibilityFeatures();
    }
  }

  addButtonInteractions() {
    // Add click analytics or tracking if needed
    this.button.addEventListener('click', (e) => {
      this.handleButtonClick(e);
    });

    // Add hover effects for better UX
    this.button.addEventListener('mouseenter', () => {
      this.button.classList.add('c-category-header__button--hover');
    });

    this.button.addEventListener('mouseleave', () => {
      this.button.classList.remove('c-category-header__button--hover');
    });

    // Add focus/blur for keyboard navigation
    this.button.addEventListener('focus', () => {
      this.button.classList.add('c-category-header__button--focus');
    });

    this.button.addEventListener('blur', () => {
      this.button.classList.remove('c-category-header__button--focus');
    });
  }

  addAccessibilityFeatures() {
    // Ensure proper ARIA attributes
    if (!this.button.getAttribute('role')) {
      this.button.setAttribute('role', 'button');
    }

    // Add keyboard support for Enter and Space keys
    this.button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.button.click();
      }
    });
  }

  handleButtonClick(event) {
    // Add any custom click handling logic here
    // For example, analytics tracking:
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        event_category: 'Category Header',
        event_label: 'Shop All Button',
        value: 1
      });
    }

    // Add loading state if needed
    this.button.classList.add('c-category-header__button--loading');
    
    // Remove loading state after a short delay (simulating navigation)
    setTimeout(() => {
      this.button.classList.remove('c-category-header__button--loading');
    }, 300);
  }

  // Method to update button text dynamically
  updateButtonText(newText) {
    if (this.button) {
      this.button.textContent = newText;
    }
  }

  // Method to update button URL dynamically
  updateButtonUrl(newUrl) {
    if (this.button) {
      this.button.href = newUrl;
    }
  }

  // Method to disable/enable button
  toggleButton(enabled = true) {
    if (this.button) {
      if (enabled) {
        this.button.removeAttribute('disabled');
        this.button.classList.remove('c-category-header__button--disabled');
      } else {
        this.button.setAttribute('disabled', 'disabled');
        this.button.classList.add('c-category-header__button--disabled');
      }
    }
  }
}

// Auto-initialize all category header components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const categoryHeaders = document.querySelectorAll('.c-category-header');
  
  categoryHeaders.forEach(header => {
    new CategoryHeader(header);
  });
});

// Export for potential module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CategoryHeader;
}

// Global namespace for theme compatibility
window.CategoryHeader = CategoryHeader;